import { RefObject, useEffect, useRef } from 'react'

// Calls `onOutside` on any mousedown landing outside `ref`'s element. Used by
// the dropdown/off-canvas menus (LangSwitcher, both SideMenus) to dismiss
// themselves when the user clicks away.
//
// `onOutside` is kept in a ref so the listener is attached once and callers can
// pass an inline arrow without re-subscribing on every render.
export const useOutsideAlerter = (
  ref: RefObject<HTMLElement | null>,
  onOutside: () => void
) => {
  const onOutsideRef = useRef(onOutside)

  useEffect(() => {
    onOutsideRef.current = onOutside
  }, [onOutside])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const element = ref.current
      if (
        element &&
        event.target instanceof Node &&
        !element.contains(event.target)
      ) {
        onOutsideRef.current()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref])
}

export default useOutsideAlerter
